export function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

export function handleize(string) {
  return string.toLowerCase().replace(/[^a-zA-Z0-8 ]/g, "").replace(/ /g, '-')
}

// Highlight keywords in post text
export function highlightMarkdown(markdown, searchString){
  if (searchString) {
    const newphrase = markdown.replace(new RegExp(searchString.trim(), 'gi'), function(instance){
      return `~~${instance}~~`
    })

    return newphrase;
  }

  return markdown;
}

function addAriaLive(e) {
  const button = e.target
  button.setAttribute('aria-live', 'polite')
}

// Add event listener too all click to copy elements {
export function addEventListenerClickCopy(className) {
  const clickToCopyBtns = document.querySelectorAll(className)

  clickToCopyBtns.forEach(btn => {
    btn.addEventListener('focus', addAriaLive)
  })
}

// Remove event listener too all click to copy elements {
export function removeEventListenerClickCopy(className) {
  const clickToCopyBtns = document.querySelectorAll(className)

  clickToCopyBtns.forEach(btn => {
    btn.addEventListener('focus', addAriaLive)
  })
}

export function resetPageFocus() {
  document.querySelector('.js-page-focus').focus()
}
